// Phase 9 R2 — Restock (positive qty + optional unit cost).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useRestockInventory() {
  const { activeShop } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      qty,
      unit_cost,
      notes,
    }: {
      id: string;
      qty: number;
      unit_cost?: number | null;
      notes?: string | null;
    }) => {
      const { data, error } = await supabase.rpc('restock_inventory', {
        p_id: id,
        p_qty: qty,
        p_unit_cost: unit_cost ?? undefined,
        p_notes: notes ?? undefined,
      });
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['inventory-items', activeShop?.id] });
      qc.invalidateQueries({ queryKey: ['inventory-transactions', activeShop?.id, vars.id] });
      toast.success('Restock recorded');
    },
    onError: (e: any) => toast.error(e?.message ?? 'Restock failed'),
  });
}
